import { render } from "./ClassicBook.vue?vue&type=template&id=8bc0f3ee&scoped=true"
import script from "./ClassicBook.vue?vue&type=script&lang=js"
export * from "./ClassicBook.vue?vue&type=script&lang=js"

import "./ClassicBook.vue?vue&type=style&index=0&id=8bc0f3ee&lang=css"
import "./ClassicBook.vue?vue&type=style&index=1&id=8bc0f3ee&scoped=true&lang=css"

import exportComponent from "/Volumes/P310_1T/workspace_cpp/slls_txt/slls-web-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bc0f3ee"]])

export default __exports__